import {is_in_array} from "./is_in_array";

export function add_or_remove_from_array(array, item, add = is_in_array(array, item)) {
	if (add) {
		array.push(item);
	} else {
		array.splice(array.indexOf(item), 1);
	}
}
